import { render, staticRenderFns } from "./siderFilterAssistants.vue?vue&type=template&id=78365a15&scoped=true&"
import script from "./siderFilterAssistants.vue?vue&type=script&lang=js&"
export * from "./siderFilterAssistants.vue?vue&type=script&lang=js&"
import style0 from "./siderFilterAssistants.vue?vue&type=style&index=0&id=78365a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78365a15",
  null
  
)

export default component.exports